export let UnsupportedReason;
(function (UnsupportedReason) {
  UnsupportedReason["MISSING_SHARED_WORKER_SUPPORT"] = "MISSING_SHARED_WORKER_SUPPORT";
  UnsupportedReason["UNSUPPORTED_USER_AGENT"] = "UNSUPPORTED_USER_AGENT";
  UnsupportedReason["EMBEDDED"] = "EMBEDDED";
  UnsupportedReason["INAPPLICABLE"] = "INAPPLICABLE";
  UnsupportedReason["PARENT_IS_EMBEDDED"] = "PARENT_IS_EMBEDDED";
  UnsupportedReason["PORTAL_ID_IS_MISSING"] = "PORTAL_ID_IS_MISSING";
  UnsupportedReason["NON_APP_DOMAIN"] = "NON_APP_DOMAIN";
})(UnsupportedReason || (UnsupportedReason = {}));